/// <reference path="../../../../../../rcwebmodels/ReeferCommands.cs.d.ts" />
/// <reference path="../../../../../../rcwebmodels/reefercommandstatus.cs.d.ts" />
/// <reference path="../../../../../../rcwebmodels/PreTrip.cs.d.ts" />
import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
import $ from 'jquery';
import ReeferStatus from '../../routecomponents/ReeferStatus';
import Formatters from '../../../actions/Formatters';
import ReeferFormatters from '../../../actions/ReeferFormatter';
import { RCUtils } from './../../../RCUtils';
import { PopupWindow } from '../../sharedcomponents/PopupWindow';
import { GridToolBarPopups } from '../../sharedcomponents/GridToolBarPopups';
import { ReeferStatusGrid } from '../../childcomponents/ReeferStatusGrid';
import { ReeferStatusSSRMGrid } from '../../childcomponents/ReeferStatusSSRMGrid';
import ReeferDetails from '../../routecomponents/ReeferDetails';
import VesselStatus from '../../routecomponents/VesselStatus';
import DateFormat from 'dateformat';
//import { DateTime } from 'react-datetime-bootstrap';
import DatePicker from 'react-datepicker';
//import * as moment from 'moment';
import moment from 'moment';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-fresh.css';
//import 'react-datepicker/dist/react-datepicker.css';
import * as Autosuggest from 'react-autosuggest';
import * as RCNGWindow from '../../sharedcomponents/ConfirmationWindow';
import { ReeferCellRenderer } from '../../../actions/ReeferCellRenderer';
var Config: any = require('../../../Config.json');
var date = new Date();
var reeferData;
var colDefs;
var selectedRowUnitMasterIds;
var command;
var startDate;
var StartDate;
var endDate;
var EndDate;

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage: false };

export interface PreTripGridState {
    cmdFilters: server.PreTripCommnadFilters;
    SelectedReefers: any[];
    rowData: server.USP_UnitCurrentConditionUI_Model[];
    columnDefs: any[];
    Filters: any;
    fwdCmdResult: server.ForwardCommandResultData;
    IsscheduleTrip: boolean;
    validateOEMType: any;
    title: string;
    SuggestionsGeofenceNames: any[];
    GeofenceNamesList: any[];
    VCCheckBoxInfo: VCCheckBoxData;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}

export class PreTrip extends React.Component<any, PreTripGridState> {
    constructor(props: any) {
        super(props);
        //var filterSet = new ForwardCommandParams();
        //var fwdcmd = new ForwardCommandResultData();
        //var validoemtype = new validateOEMType();
        this.settingDates();
        var validoemtype: server.ValidateOEMType = { RefCustSpecificCommandCnt: 0, Msg: null, Title: null, RefCustomerSpecificCommand: [], SelectedReefers: [], command: null };
        var filterSet: server.ForwardCommandParams = { SelectedReefers: [], CommandName: null, TempValue: null, PreTripCmdFilters: null, TraditionalDownload: null, lstAutoConfigParams: null, IsCmdSendViaVC: null, VesselInfo: null};
        var fwdcmd: server.ForwardCommandResultData = { CurrentCondition: null, IsError: false, Tooltip: null, IsTooltipVisisble: null, IsPending: null, UnitMasterId: 0, LastPreTripDTTM: null, PTIState: null, Command: null, PreTripCmdFilters: null };
        var cmdfilter: server.PreTripCommnadFilters = { StartDate: StartDate, EndDate: EndDate, Geofence: '', IsScheduledPreTrip: false, GeofenceID: null, GeofenceTagName: null, IsPreTripSubmitted: false };
        this.state = { rowData: [], cmdFilters: cmdfilter, SelectedReefers: [], columnDefs: [], Filters: filterSet, fwdCmdResult: fwdcmd, IsscheduleTrip: false, validateOEMType: validoemtype, title: null, SuggestionsGeofenceNames: [], GeofenceNamesList: [], VCCheckBoxInfo: emptyVCCheckBoxData, IsCommandIssued: false, PrevSelectedItems: []};
        colDefs = this.createColumnDefs();
        command = props.preTripCmd; 

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetGeofences')
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.GeofenceList[]>)
            .then(data => {
                this.setState({ GeofenceNamesList: data });
            }); 
    }

    componentDidMount() {
        var reeferData = this.props.reeferData;        
        if (reeferData.length > 0) {
            if (reeferData != undefined && reeferData != null) {
                this.setState({ SelectedReefers: reeferData });
                //this.setState({ rowData: reeferData, SelectedReefers: reeferData });
                this.getDataFromAPI(reeferData);
            }
        } 
        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }

       
       
        
        
        $(".inputdisabled > .input-group ").removeClass('enabled');
        $(".inputdisabled > .input-group ").addClass('disabled');    

        RCNGWindow.ConfirmWindow.close();
    }

    componentDidUpdate() {
        if (this.state.cmdFilters.IsScheduledPreTrip) {
            $('#txtGeofenceName').removeAttr('disabled');
        }
        else {
            $('#txtGeofenceName').attr('disabled', 'disabled');            
        }       
    }
    
    componentWillReceiveProps(nextprops: any) {
        var reeferData = nextprops.reeferData;
        var filters = this.state.cmdFilters;
        command = nextprops.preTripCmd;
        this.settingDates();
        filters.Geofence = "";
        filters.EndDate = EndDate;
        filters.StartDate = StartDate;
        filters.IsScheduledPreTrip = false;
        this.setState({ cmdFilters: filters });

        $('#geofenceName').prop('disabled', true);
        $(".inputdisabled > .input-group ").removeClass('enabled');
        $(".inputdisabled > .input-group ").addClass('disabled');  
        this.setState({ IsscheduleTrip: false });
        if (reeferData.length > 0) {
            if (reeferData != undefined && reeferData != null) {
                this.setState({ SelectedReefers: reeferData });
                this.getDataFromAPI(reeferData);
                this.validateOEMType(reeferData, command);
            }
        }
        if (nextprops.VCCheckBoxInfo != undefined && nextprops.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextprops.VCCheckBoxInfo });
        }
    }
    //*----Validations-------*//
    settingDates() {
        startDate = DateFormat(new Date(Date.now()), 'mm/dd/yyyy');
        StartDate = DateFormat(new Date(moment(new Date(startDate)).startOf('day').toString()), 'mm/dd/yyyy HH:MM:ss');
        endDate = moment(new Date(startDate)).endOf('day').toString();
        EndDate = DateFormat(new Date(endDate), 'mm/dd/yyyy HH:MM:ss');
    }

    validateOEMType(reeferData: any, cmd: string) {
        this.state.validateOEMType.SelectedReefers = this.state.SelectedReefers;
        this.state.validateOEMType.command = cmd; //from UI
        var validateOEMType = JSON.stringify(this.state.validateOEMType);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ValidateOEMType', { method: 'POST', body: validateOEMType, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.ValidateOEMType>)
            .then(data => {
                if (data.Msg != null) {
                    PopupWindow.showErrorMessage("Alert", "Selected reefer(s) must have a valid OEM type.");
                }
                else {
                    this.setState({ title: data.Title });
                }
            });
    }

    commandFromDateChange(date) {
        var filters = this.state.cmdFilters;
        filters.StartDate = DateFormat(new Date(date.toString()), 'mm/dd/yyyy HH:MM:ss');
        this.setState({
            cmdFilters: filters
        });
    }

    commandToDateChange(date) {
        var filters = this.state.cmdFilters;
        filters.EndDate = DateFormat(new Date(date.toString()), 'mm/dd/yyyy HH:MM:ss');
        this.setState({
            cmdFilters: filters
        });
    }

    geofenceChange = (event, { newValue }) => {
        var filters = this.state.cmdFilters;
        var value: string = event.currentTarget.value;
        filters.Geofence = newValue;
        this.setState({
            cmdFilters: filters
        });
    };

    refreshGrid = () => {
        $('#globalLoader').show();
        this.getDataFromAPI(this.state.SelectedReefers);
        $('#globalLoader').hide();
    };

    scheduleTripSelected(event) {
        var filters = this.state.cmdFilters;
        filters.IsScheduledPreTrip = !this.state.IsscheduleTrip;
        this.setState({
            cmdFilters: filters,
            IsscheduleTrip: !this.state.IsscheduleTrip
        });

        if (this.state.cmdFilters.IsScheduledPreTrip) {
            $(".inputdisabled > .input-group ").removeClass('disabled');  
            $(".inputdisabled > .input-group ").addClass('enabled');  
            $('#txtGeofenceName').prop('disabled', false);
        }
        else {
            var filters = this.state.cmdFilters;
            filters.Geofence = "";
            filters.StartDate = new Date();
            filters.EndDate = new Date();
            this.setState({ cmdFilters: filters });
            $('#txtGeofenceName').prop('disabled', true);
            $(".inputdisabled > .input-group ").removeClass('enabled');
            $(".inputdisabled > .input-group ").addClass('disabled');  
        }
    }

    //*--------Validations End---------------*//
    //*-----Start Grid Related-----*//
    getDataFromAPI(reeferData) {
        this.state.Filters.SelectedReefers = reeferData;        
        this.state.Filters.CommandName = command;
        var forwardCommandParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/LoadPTIData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(data => {
                this.setState({ rowData: data });
            });
    }

    onGridReady(params: any) {
        params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        //this.gridApi.forEachNode(node => node.rowIndex ? 0 : node.setSelected(true));
        //this.gridApi.sizeColumnsToFit();      
    }

    //removeIndicator(params: any) {
    //    var element = document.createElement("span");
    //    element.className = "reefer-delete";
    //    var imageElement = document.createElement("img");
    //    imageElement.src = deletepng;
    //    imageElement.title = "Remove";
    //    imageElement.onclick = function DeleteCommands() {
    //        params.api.gridOptionsWrapper.gridOptions.rowData.splice(params.rowIndex, 1);
    //        params.api.setRowData(params.api.gridOptionsWrapper.gridOptions.rowData);
    //    }
    //    element.appendChild(imageElement);
    //    return element;
    //}

    createColumnDefs() {
        return [
            { headerName: "Remove", field: "ReeferID", width: 85, cellRenderer: ReeferCellRenderer.removeIndicator },
            { headerName: "State", field: "IsPending", width: 80, cellRenderer: ReeferCellRenderer.CommandValidator, tooltipField: "Tooltip" },
            { headerName: "CC", field: "CCSeverityLevel", width: 65, valueGetter: (params) => { return ReeferFormatters.CargoCareSorting(params); }, cellRenderer: ReeferCellRenderer.CargoCareFormatter },
            { headerName: "ALM", field: "MASeverityLevel", width: 65, cellRenderer: ReeferCellRenderer.statusIndicatorforALM },
            { headerName: "RUN", field: "RunState", width: 65, cellRenderer: ReeferCellRenderer.RunStateFormatter },
            { headerName: "VSL", field: "VesselCd", width: 80, cellRenderer: ReeferCellRenderer.StringTypeFormatter },
            { headerName: "OEM", field: "ReeferOEMTypeCd", cellRenderer: Formatters.oemTypeFormatter, width: 70 },
            { headerName: "Reefer ID", field: "ReeferID", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140 },
            { headerName: "T set ", field: "SetPoint", width: 80, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "T sup 1 ", field: "SupplyTemp1", width: 100, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "T rtn 1 ", field: "ReturnTemp1", width: 100, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "RH set", field: "HumiditySetpoint", cellRenderer: ReeferFormatters.HumiditySetpointFormatter, width: 80 },
            { headerName: "Last event", field: "EventDescription", cellRenderer: (params) => { return ReeferFormatters.EventDescriptionFormatters(params, this.props.reeferFormatter.CustomerSpecificEventList, this.props.reeferFormatter.EventMasterList, this.props.reeferFormatter.M_CustomerAssetTypeDeviceTypeSensorAlerts, this.props.reeferFormatter.Ref_SensorAlerts); }, width: 100 },
            { headerName: "Event time ", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
            { headerName: "Alarm", field: "AlarmsList", cellRenderer: ReeferCellRenderer.AlarmListFormatter, width: 70 },
            { headerName: "Last pretrip time ", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "LastPreTripDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 190 },
            { headerName: "PTI state", field: "PTIState", cellRenderer: Formatters.RefCommandStatus, width: 100 }
        ];
    }

    onSelectionChanged(params: any) {
        var unitmasterids = this.state.fwdCmdResult;
        var selectedRows = params.api.getSelectedRows();
        unitmasterids.UnitMasterId = selectedRows[0].UnitMasterID;
        unitmasterids.Command = command;
        this.setState({ fwdCmdResult: unitmasterids });
    }
    //*-----End Grid Related-----*//
    //*----Submit------*//
    validatePreTripGeofence() {
        this.state.Filters.PreTripCmdFilters = this.state.cmdFilters;
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ValidatePreTripGeofence?geofence=' + this.state.cmdFilters.Geofence, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_GetSelectedGeofence_Result[]>)
            .then(data => {
                var cmdfilters = this.state.cmdFilters;
                if (data.length > 0) {
                    var selectedGeo = data[0];
                    cmdfilters.GeofenceTagName = selectedGeo.Tag + "/" + selectedGeo.Name;
                    cmdfilters.GeofenceID = selectedGeo.GeofenceID;
                    this.validatePretripDates();
                }
                else {
                    cmdfilters.GeofenceTagName = null;
                    cmdfilters.GeofenceID = null;
                    PopupWindow.showErrorMessage("Alert", "Goefence is not available");
                    $('#globalLoader').hide();
                }
                this.setState({ cmdFilters: cmdfilters });
            });
    }

    validatePretripDates() {
        var unitMasterID;
        var selectedReeferdata = JSON.parse(JSON.stringify(this.state.Filters.SelectedReefers));
        if (selectedReeferdata != undefined && selectedReeferdata[0].UnitMasterID != undefined) {
            unitMasterID = selectedReeferdata[0].UnitMasterID;
        } else {
            unitMasterID = this.state.fwdCmdResult.UnitMasterId;
        }
        this.state.fwdCmdResult.Command = command;
        this.state.fwdCmdResult.UnitMasterId = unitMasterID;
        this.state.fwdCmdResult.PreTripCmdFilters = this.state.Filters.PreTripCmdFilters;
        var fwdcmdresult = JSON.stringify(this.state.fwdCmdResult);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ValidatePretripDates', { method: 'POST', body: fwdcmdresult, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<string>)
            .then(data => {
                if (data == "Exists") {
                    var cmdpretripfliters = this.state.cmdFilters;
                    cmdpretripfliters.IsPreTripSubmitted = false;
                    this.setState({ cmdFilters: cmdpretripfliters });
                    PopupWindow.showErrorMessage("Alert", "Schedule PreTrip already exists with same prerequisite.");
                    $('#globalLoader').hide();
                }
                else
                    this.submitTemperatureCommands();
            });
    }

    submitPreTripCommand() {
        if (this.state.rowData.length > 0) {
            if (this.state.cmdFilters.IsScheduledPreTrip == true && this.state.VCCheckBoxInfo.enableVCCheckBox == true)
                PopupWindow.showErrorMessage("Alert", "Selected Reefer(s) are on vessel, Scheduling Pretrip is not allowed");
            else if (this.state.cmdFilters.IsScheduledPreTrip == true && this.state.VCCheckBoxInfo.isVCMessage == true) {
                var confirmationMessage = "Selected Reefer(s) are on vessel. Are you sure you want to issue the command?";
                RCNGWindow.ConfirmWindow.showConfirmBox(confirmationMessage, this.submitCommandAction.bind(this), this.closeConfirmation.bind(this));
            }
            else
                this.submitPreTripCommandConfirmation();
        }
        else
            PopupWindow.showErrorMessage("Alert", "No assets selected");
    }

    closeConfirmation() {
        RCNGWindow.ConfirmWindow.close();
    }
    submitCommandAction() {
        RCNGWindow.ConfirmWindow.close();
        this.submitPreTripCommandConfirmation();
    }

    submitPreTripCommandConfirmation() {
        $('#globalLoader').show();
        this.state.Filters.CommandName = command;
        this.state.Filters.SelectedReefers = this.state.rowData;
        this.state.Filters.PreTripCmdFilters = this.state.cmdFilters;
        var forwardCommandParams = JSON.stringify(this.state.Filters);
        var validationParams = JSON.stringify(this.state.Filters.PreTripCmdFilters);       
        if (this.state.cmdFilters.IsScheduledPreTrip == true) {
            var validationResult = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ValidatePreTripCommand', { method: 'POST', body: validationParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(validationResult)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<string>)
                .then(data => {
                    if (data == "Success") {
                        if (this.state.cmdFilters.Geofence != undefined && this.state.cmdFilters.Geofence != null && this.state.cmdFilters.Geofence != "") {
                            this.validatePreTripGeofence();
                        }//Geofoence empty checking
                        else {
                            this.validatePretripDates();
                        }
                    }
                    else {
                        PopupWindow.showErrorMessage("Alert", data.toString());
                        $('#globalLoader').hide();
                    }
                });
        }
        else
            this.submitTemperatureCommands();
    }

    submitTemperatureCommands() {
        var selectedData = this.state.VCCheckBoxInfo.selectedVCData;
        if (this.state.VCCheckBoxInfo.enableVCCheckBox == true && (selectedData == null || selectedData.VesselId == 0))
        {
            PopupWindow.showErrorMessage("Alert", "Please select vessel name");
            $('#globalLoader').hide();
        }
        else {
            $('#globalLoader').show();
            var refreshGrid = this.props.refreshGrid;
            this.state.Filters.CommandName = command;
            this.state.Filters.SelectedReefers = this.state.rowData;
            this.state.Filters.PreTripCmdFilters = this.state.cmdFilters;
            this.state.Filters.IsCmdSendViaVC = this.state.VCCheckBoxInfo.enableVCCheckBox;
            this.state.Filters.VesselInfo = this.state.VCCheckBoxInfo.selectedVCData;
            var forwardCommandParams = JSON.stringify(this.state.Filters);
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/PreTripCommands', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response)
                .then(data => {
                    //($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
                    //$("#Hide_" + this.state.Filters.CommandName).click();
                    $("#contextMenuModel .btn-close").click();
                    this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
                    if (refreshGrid == "details")
                        ReeferDetails.refreshReeferDetailsData();
                    else if (refreshGrid == "home") {
                        if (JSON.parse(sessionStorage.getItem('SSRM'))) {
                            ReeferStatusSSRMGrid.refreshDashboardGrid();
                        }
                        else {
                            ReeferStatusGrid.refreshDashboardGrid();
                        }
                    }
                    else if (refreshGrid == "vessel")
                        VesselStatus.refreshVesselStatusGrid();
                    else
                        ReeferStatus.refreshReeferStatusGrid();
                    
                });
        }
    }
    //*----Submit End----*//
    renderSuggestion(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionValue(suggestion) {
        return suggestion;
    }

    onSuggestionsClearRequested = () => {
        this.setState({
            SuggestionsGeofenceNames: []
        });
    };

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            SuggestionsGeofenceNames: this.getGeofenceNameSuggestions(value)
        });
    };

    getObjectArray(inputType: string) {
        var finalArray = this.state.GeofenceNamesList.map(function (obj) {
            switch (inputType) {
                case 'Tag':
                    return obj.Tag;
            }
        });

        return finalArray;
    }

    getGeofenceNameSuggestions(value) {
        if (value != null && value != undefined && value != '') {
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            return inputLength === 0 ? [] : this.getObjectArray('Tag').filter(Tag =>
                Tag.toLowerCase().slice(0, inputLength) === inputValue
            );
        }        
    } 
    
    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    }  

    public render() {
        const { SuggestionsGeofenceNames } = this.state;
        const GeofenceNameInputProps = {
            id: 'txtGeofenceName',
            placeholder: 'Enter Geofence Name',
            value: this.state.cmdFilters.Geofence,//  userIdvalue,
            onChange: this.geofenceChange.bind(this),
            disabled:true
        };

        return <div>
            <div className='modal-controls-container'>
                <div className='row mt-2'>
                    <div className='col-lg-3 col-md-4 col-sm-4 col-xs-3 text-start text-sm-end pe-0'>
                        <span className='col-form-label'>Schedule PreTrip:</span>
                    </div>
                    <div className='col-lg-4 col-md-3 col-sm-4 col-xs-4'>
                        <input type="checkbox" className='checkbox20' id="isSchuleTrip" name="chkschdule" onChange={this.scheduleTripSelected.bind(this)} checked={this.state.IsscheduleTrip} />
                    </div>
                </div>
                <div className='row mt-2'>
                    <div className='col-lg-3 col-md-4 col-sm-4 col-xs-3 text-start text-sm-end pe-0' id="PretripdatePickers" >
                        <label className='col-form-label'> Time Window Start:</label>
                    </div>
                    <div className='col-lg-3 col-md-8 col-sm-8 col-xs-9 inputdisabled'>
                        <div className="date">
                            <DatePicker
		                        selected={new Date(this.state.cmdFilters.StartDate)}
		                        onChange={this.commandFromDateChange.bind(this)}
		                        timeInputLabel="Time:"
		                        dateFormat="MM/dd/yyyy hh:mm aa"
		                        showTimeInput  
		                        className=""
                                id="fDate"                          
	                        />
                            
                        </div>
                    </div>
                    <div className='col-lg-3 col-md-4 col-sm-4 col-xs-3 text-start text-sm-end pe-0'>
                        <label className='col-form-label'>Time Window End:</label>
                    </div>
                    <div className='col-lg-3 col-md-8 col-sm-8 col-xs-9 inputdisabled'>
                        <div className="date">
                            <DatePicker
		                        selected={new Date(this.state.cmdFilters.EndDate)}
		                        onChange={this.commandToDateChange.bind(this)}
		                        timeInputLabel="Time:"
                                showYearDropdown
                                yearDropdownItemNumber={5}
		                        dateFormat="MM/dd/yyyy hh:mm aa"
		                        showTimeInput  
		                        className=""
                                id="eDate"                           
	                        />                            
                        </div>
                    </div>
                </div>
                <div className='row mt-2'>
                    <div className='col-lg-3 col-md-4 col-sm-4 col-xs-3 text-start text-sm-end pe-0'>
                        <label className='col-form-label'>Geofence:</label>
                    </div>
                    <div className='col-lg-9 col-md-8 col-sm-8 col-xs-9 inputdisabled'>
                        <Autosuggest name="GeofenceName" id="txtGeofenceName"
                            suggestions={SuggestionsGeofenceNames}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                            getSuggestionValue={this.getSuggestionValue}
                            renderSuggestion={this.renderSuggestion}
                            inputProps={GeofenceNameInputProps}
                            highlightFirstSuggestion={true}                            
                        />
                    </div>
                </div>
            </div>
            <div>
                <GridToolBarPopups refreshGrid={this.refreshGrid.bind(this)} gridData={this.state.rowData} colDefs={colDefs} parentchild={"P"} formName={"PreTrip"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)}/>
            </div>
            <div className='row'>
                <div className='col-md-12'>
                    <div className="ag-theme-fresh containerstyle_commands">
                        <AgGridReact
                            columnDefs={colDefs}
                            rowData={this.state.rowData}
                            onGridReady={this.onGridReady}
                            rowSelection={'single'}
                            onSelectionChanged={this.onSelectionChanged.bind(this)}
                            pagination={true}
                            accentedSort={true}
                            paginationPageSize={25}>
                        </AgGridReact>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitPreTripCommand.bind(this)}>Save</button>
            </div>
        </div>
    }
}


//class ForwardCommandParams {
//    SelectedReefers: server.USP_UnitCurrentConditionUI_Model[];
//    CommandName: string;
//    TempValue: any;
//    PreTripCmdFilters: server.PreTripCommnadFilters;
//}
//class PreTripCommnadFilters {
//    Geofence: string;
//    IsScheduledPreTrip?: boolean;
//    StartDate?: Date;
//    EndDate?: Date;
//    GeofenceID?: number;
//    GeofenceTagName?: string;
//    IsPreTripSubmitted: boolean;
//}

//class ForwardCommandResultData {
//    currentcondition: server.USP_UnitCurrentConditionUI_Model;
//    IsError: boolean;
//    Tooltip: string;
//    IsTooltipVisisble: string;
//    IsPending: string;
//    UnitMasterId: Number;
//    LastPreTripDTTM?: Date;
//    PTIState: string;
//    Command: string;
//    PreTripCmdFilters: server.PreTripCommnadFilters;

//}

//class validateOEMType {
//    RefCustSpecificCommandCnt: Number;
//    Msg: string;
//    Title: string;
//    RefCustomerSpecificCommand: server.RefCustomerSpecificCommand[];
//    SelectedReefers: server.USP_UnitCurrentConditionUI_Model[];
//    command: string;
//}
